// extracted by mini-css-extract-plugin
export default {"wrapper":"gHoDRt","label":"UUezir","value":"_131Qnr","caption":"K4qJUg","section--l":"gW_hwR","section--s":"m6JLAq","list":"X_iCbW"};